// src/plugins/vuetify.js

import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

const opts = {
  icons: {
    iconfont: 'mdiSvg',
  },
  theme: {
    dark: false,
    themes: {
      light: {
        primary: '#0096A6', 
        // #0096A6
        // #248A9A
        // #41B0C1
        accent: '#F04854',
        // #F04854
        secondary: '#69BE28',
        // #69BE28
        success: '#D5F884', 
        // #D5F884
        info: '#002244', 
        // #002244
        warning: '#FEB06A', 
        // #FEB06A
        error: '#F04881', 
        // #F04881
        pewter: '#E9EAEC', 
        // #E2E4E7
        coffee: '#505149', 
        // #505149
        heavy: '#092224', 
        // #092224

        // #FF5722 deep-orange 
        // #F4511E deep-orange darken-1

        background: '#e4ecf0', 
        // #e4ecf0
        light_primary: '#CCEAED',
        // #CCEAED
        xtralight_primary: '#eef7f8', 
        // #eef7f8
        q_secondary: '#97C131', 
        // #97C131

        status_progress: '#94BB50',
        // #94BB50 green
        // #79A036 green darken-1
        status_wait: '#EFBF04',
        // #EFBF04 gold
        // #FFEB3B yellow *old
        // #FDD835 yellow darken-1 *
        status_pause: '#FF9800', 
        // #FF9800 orange
        // #FFB32F orange lighten-1
        // #DF7E00 orange darken-1
        status_hold: '#F44336', 
        // #F44336 red
        // #FF614E red lighten-1
        // #D31F1F red darken-1
        status_complete: '#41B0C1',
        // #41B0C1 teal 
        // #248a9a 
        // #0096A6
        status_upgrade: '#03A9F4', 
        // #03A9F4 light-blue
        status_downgrade: '#03A9F4', 
        // #03A9F4 light-blue
        status_refunded: '#d836f4',
        // #d836f4 purple
        status_closed: '#505149', 
        // #505149 grey

        general_grey: '#5F6062',
        // #5F6062 same as - grow
        general_lightgrey: '#E6E7E8',
        // #E6E7E8
      }
    },
    options: { 
      variations: true,
      customProperties: true
    },
    typography: {
      fontFamily: [
        'Sansation',
        'Avenir',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
      ].join(','),
    }
  }
};

Vue.use(Vuetify)

export default new Vuetify( opts );


// WEBPACK FOOTER //
// ./src/plugins/vuetify.js